import * as React from "react";
import { SecuredHeader } from "./SecuredHeader";
import { SecuredMainNavigation } from "./SecuredMainNavigation";
import { SecuredFooter } from "./SecuredFooter";
import CoachMarkerProvider from "../../Shared/CoachMarkers/CoachMarkerContext";
import { SessionTimeoutComponent } from "../../Shared/Session/SessionTimeoutComponent";
import CookiePolicy from "../../Shared/Cookies/ChoicesCookie/CookiePolicy.component";

interface ISecuredProps extends React.Props<Secured> {}

interface ISecuredState {
    contentElement?: JSX.Element;
}

export class Secured extends React.Component<ISecuredProps, ISecuredState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { contentElement } = this.state;

        return (
            <CoachMarkerProvider>
                <div className="anim-navigation-wrapper">
                    <a href="#main" className="sr-only">
                        Skip to main content
                    </a>
                    <div className="layout-secured">
                        <div className="layout-secured-header">
                            <SecuredHeader />
                        </div>

                        <div className="layout-secured-content">
                            <div className="container">
                                <div className="layout-secured-leftbar">
                                    <SecuredMainNavigation />
                                </div>
                                <div className="layout-secured-page">
                                    <div className="anim-navigation-wrapper">
                                        <div>{this.props.children}</div>
                                    </div>
                                    <div className="layout-secured-footer">
                                        <SecuredFooter />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SessionTimeoutComponent />
                </div>
            </CoachMarkerProvider>
        );
    }
}
